import { User, UserContact, UserCredentials, UserList } from "pwapi";

export const getUserNameStringWithCredentials = (
  user:
    | User
    | UserContact
    | UserCredentials
    | (UserList & { credentials?: string }),
  isFirstNameLastName: boolean = false
): string => {
  const credentials = user.userprofile?.credentials || user.credentials;
  return isFirstNameLastName
    ? `${getNameString(
        user?.first_name,
        user?.last_name,
        isFirstNameLastName
      )}${credentials ? `, ${credentials}` : ""}`
    : `${getNameString(
        user?.first_name,
        user?.last_name,
        isFirstNameLastName
      )}${credentials ? ` ${credentials}` : ""}`;
};

export const getNameString = (
  first_name?: string | null,
  last_name?: string | null,
  isFirstNameLastName: boolean = false
): string => {
  if (!first_name && !last_name) return "";
  //Filters names to prevent issues such as missing last names or first names, i.e. Cher.
  return isFirstNameLastName
    ? [first_name, last_name].filter((name) => name).join(" ")
    : [last_name, first_name].filter((name) => name).join(", ");
};
